<template>
    <v-dialog v-model="show" no-click-animation persistent width="1000">
        <div class="ScenarioAudio">
            <!-- Header dialog -->
            <div class="dialog-header">
                <div>{{ $f.tc('audio') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!-- Content dialog -->
            <div class="dialog-content fci-scrollbar" ref="contentDialog">
                <!--Table variables-->
                <table>
                    <thead>
                    <tr>
                        <th>{{ $f.tc('name') }}</th>
                        <th>{{ $f.tc('audio') }}</th>
                        <th>{{ $f.tc('description') }}</th>
                        <th v-if="isEdit" style="width: 11%"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--Current audio-->
                    <tr v-for="(item, i) in audios" :key="i">
                        <td>
                            <v-text-field
                                outlined
                                v-model="item.name"
                                class="input-custom"
                                :readonly="!isEdit"
                            ></v-text-field>
                        </td>
                        <td>
                            <audio :src="item.audio" controls style="height: 32px;min-width: 100%"></audio>
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="item.description"
                                class="input-custom"
                                :readonly="!isEdit"
                            ></v-text-field>
                        </td>
                        <td v-if="isEdit" style="display: flex">
                            <v-btn icon class="mx-0" @click.stop="openEditAudioUrl(item,i)">
                                <img src="/img/edit-blue.svg" alt="icon-edit" style="transform: scale(1.1);">
                            </v-btn>
                            <v-btn icon class="mx-0" @click.stop="deleteAudio(i)">
                                <img src="/img/delete-blue.svg" alt="icon-delete"
                                     style="transform: scale(1.1); padding-left: 1px">
                            </v-btn>
                        </td>
                    </tr>
                    <!--New variable-->
                    <tr v-if="isEdit">
                        <td>
                            <v-text-field
                                outlined
                                v-model="name"
                                class="input-custom"
                                @keypress.enter="addAudio"
                                :placeholder="$f.tc('name')"
                                style="width: 100%"
                                ref="NewKeyVariable"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-text-field
                                label="Selected File"
                                @click="importAudio"
                                v-model="fileName"
                                class="input-custom"
                                v-if="showInput"
                                readonly
                            ></v-text-field>
                            <input
                                type="file"
                                style="display: none"
                                ref="audio"
                                accept="audio/*"
                                @change="handleFile"
                            >
                        </td>
                        <td>
                            <v-text-field
                                outlined
                                v-model="description"
                                class="input-custom"
                                style="width: 100%"
                                :readonly="!isEdit"
                            ></v-text-field>
                        </td>
                        <td>
                            <v-btn icon class="mx-0" @click.stop="addAudio">
                                <img src="/img/add-blue.svg" alt="icon-delete" style="transform: scale(1.4);">
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <!-- Footer dialog -->
            <div class="dialog-footer" v-if="isEdit">
                <div class="btn-custom" @click="saveAudio">{{ $f.tc('save') }}</div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
        <AudioEdit ref="AudioEdit" @updateAudioUrl="updateAudioUrl"></AudioEdit>
    </v-dialog>
</template>

<script>
import DialogPromiseMixin from '@/modules/fptai/mixins/DialogPromiseMixin'
import ScenarioService from '@/services/scenario.service'
import lodash from 'lodash'
import {mapState} from 'vuex'
import AudioEdit from '@/views/Scenario/AudioEdit'
import {ruleMaxLengthStr} from '@/modules/fptai/utils/FormRules'

export default {
    name: 'ScenarioAudio',
    components: {
        AudioEdit
    },
    mixins: [DialogPromiseMixin],
    data() {
        return {
            name: '',
            audio: '',
            description: '',
            file: null,
            fileName: '',
            showInput: true,
            isLoading: false,
        }
    },
    computed: {
        ...mapState({
            audioList: state => state.scenario.scenarioAudioList,
            nodeList: state => state.scenario.treeData ? state.scenario.treeData.nodeList.filter(item => {
                return item.type === 'PROCESS'
            }) : []
        }),
        isEdit() {
            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        },
        audios() {
            return lodash.orderBy(this.$utils.cloneObject(this.audioList), 'name')
        },
        originalItemMap() {
            let map = {}
            for (let item of this.audioList) {
                map[item.id] = item
            }
            return map
        }
    },
    methods: {
        loadDictionary() {
            this.$store.dispatch(this.$actionTypes.scenario.GET_SCENARIO_AUDIO, this.$route.params.scenarioId)
        },
        open() {
            this.loadDictionary()
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        close() {
            this.show = false
            this.clearNewAudio()
        },
        addAudio() {
            if (this.nameIsEmpty()) {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', {item: this.$f.tc('name')}))
                return
            }
            if (this.nameTooLong()) {
                this.$appService.toastError(this.$f.tc('itemFieldTooLong', {item: this.$f.tc('name')}))
                return
            }
            if (this.nameIsExist()) {
                this.$appService.toastError(this.$f.tc('fieldItemDuplicate', {
                    key: this.$f.tc('name'),
                    value: this.name
                }))
                return
            }
            if (!this.file) {
                this.$appService.toastError(this.$f.tc('itemFieldRequired', {item: this.$f.tc('file')}))
                return
            }
            this.audios.push({
                name: this.name,
                audio: this.audio,
                file: this.file,
                description: this.description,
            })
            this.scrollBottom()
            this.clearNewAudio()
            this.$refs.NewKeyVariable.$el.focus()
        },
        nameIsEmpty() {
            return !this.name
        },
        nameIsExist() {
            let item = this.audios.find(item => item.name === this.name)
            return !!item
        },
        nameTooLong() {
            return !ruleMaxLengthStr(this.name)
        },
        clearNewAudio() {
            this.name = ''
            this.audio = ''
            this.description = ''
            this.file = null
            this.fileName = ''
            if (this.$refs.audio) {
                this.$refs.audio.value = null
            }
        },
        deleteAudio(index) {
            if (!this.checkValidDeleteAudio(index)) {
                return
            }
            this.audios.splice(index, 1)
            this.$forceUpdate()
        },
        openEditAudioUrl(item, index) {
            this.$refs.AudioEdit.open(item, index)
        },
        saveAudio() {
            let duplicated = this.hasDuplicateField(this.audios, 'name')
            if (duplicated) {
                this.$appService.toastError(this.$f.tc('fieldItemDuplicate', {
                    key: this.$f.tc('name'),
                    value: duplicated
                }))
                return
            }
            if (this.isLoading) {
                return
            }
            this.$appService.showLoading()
            let {addAudio, updateAudio, deleteAudio} = this.convertAudiosToSave()
            let promiseList = this.convertToPromise(addAudio, updateAudio, deleteAudio)
            this.handlePromise(promiseList)
        },
        scrollBottom() {
            this.$nextTick(() => {
                this.$refs.contentDialog.scrollTo({
                    top: this.$refs.contentDialog.scrollHeight
                })
            })
        },
        // upload audio
        importAudio() {
            this.$refs.audio.click()
        },
        handleFile(event) {
            let file = event.target.files[0]
            let extFile = file.name.split('.').pop()
            if (['wav', 'mp3', 'wma', 'flac', 'aac', 'ogg'].includes(extFile)) {
                if (extFile !== 'wav') {
                    this.$appService.toastWarning(this.$f.tc('warningConvertAudio'))
                }
                this.file = file
                this.fileName = file.name
            } else {
                this.$appService.toastError('invalid file')
            }
        },
        updateAudioUrl(item, index) {
            this.audios[index] = item
        },
        hasDuplicateField(arr, field) {
            const uniqueValues = []
            for (const obj of arr) {
                if (uniqueValues.includes(obj[field])) {
                    return obj[field] // Duplicate found
                }
                uniqueValues.push(obj[field])
            }
            return false // No duplicates found
        },
        convertAudiosToSave() {
            let addList = []
            let updateList = []
            let deleteList = []
            for (let item of this.audios) {
                let originalItem = this.originalItemMap[item.id]
                if (originalItem) {
                    if (!lodash.isEqual(originalItem, item)) {
                        item.id = originalItem.id
                        updateList.push(item)
                    }
                    originalItem.doNotDelete = true
                } else {
                    addList.push(item)
                }
            }

            for (let i in this.originalItemMap) {
                let item = this.originalItemMap[i]
                if (!item.doNotDelete) {
                    deleteList.push(item)
                }
            }
            return {addAudio: addList, updateAudio: updateList, deleteAudio: deleteList}
        },
        handlePromise(promiseList) {
            let i18n = {
                action: this.$t('update'),
                item: this.$t('audio')
            }
            Promise.allSettled(promiseList).then(
                resultList => {
                    this.$appService.hideLoading()
                    for (let result of resultList) {
                        if (result.status === 'rejected') {
                            this.$appService.toastError(this.$f.tc('actionFailed', i18n))
                            return
                        }
                    }
                    this.loadDictionary()
                    this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n))
                    this.close()
                }
            ).finally(() => {
                this.isLoading = false
                this.$appService.hideLoading()
            })
        },
        convertToPromise(addList, updateList, deleteList) {
            let promiseList = []
            let scenario_id = this.$route.params.scenarioId
            for (let item of addList) {
                let formData = new FormData()
                formData.append('file', item.file)
                formData.append('name', item.name)
                formData.append('audio', item.audio)
                formData.append('description', item.description)
                promiseList.push(this.$http.post(
                    `/scenarios/${scenario_id}/audios/`,
                    formData,
                    {headers: {'Content-Type': 'multipart/form-data'}}
                ))
            }
            for (let item of updateList) {
                let formData = new FormData()
                formData.append('file', item.file)
                formData.append('name', item.name)
                formData.append('audio', item.audio)
                formData.append('description', item.description)
                promiseList.push(this.$http.patch(
                    `/scenarios/${scenario_id}/audios/${item.id}/`,
                    formData,
                    {headers: {'Content-Type': 'multipart/form-data'}}
                ))
            }
            for (let item of deleteList) {
                promiseList.push(ScenarioService.ScenarioAudioService.delete(scenario_id, item.id))
            }
            return promiseList
        },
        checkValidDeleteAudio(index) {
            let useAudio = []
            if (!this.audios[index]?.slug) {
                return true
            }
            this.nodeList.forEach(item => {
                if (item.config.audio_slug === this.audios[index].slug) {
                    useAudio.push(item)
                    return
                }
                if (!item.config.rePromptList) {
                    return
                }
                item.config.rePromptList.forEach(reprompt => {
                    if (reprompt.audio_slug === this.audios[index].slug) {
                        useAudio.push(item)
                    }
                })
            })

            if (useAudio.length > 0) {
                let nodeName = ""
                if (useAudio.length > 3) {
                    let firstThree = useAudio.slice(0, 3)
                    nodeName = firstThree.map(audio => audio.name).join(', ')
                    nodeName = nodeName + ", and more"
                } else {
                    nodeName = useAudio.map(audio => audio.name).join(', ')
                }
                this.$appService.toastError(this.$f.tc("canNotDeleteAudio", [nodeName]))
                return false
            }
            return true
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioAudio {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        padding: 12px;
        max-height: calc(85vh - 100px);
        overflow-y: auto;
    }

    .btn-custom {
        margin-right: 8px;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}


table {
    border: 1px solid #96add0;
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    tr {
        height: 48px;
        border-bottom: 1px solid #96add0;

        td {
            padding: 0 6px;

            &:first-child {
                padding-left: 12px;
            }
        }
    }

    thead tr:not(.v-datatable__progress) {
        height: 48px !important;
    }

    thead th {
        text-transform: capitalize !important;
        color: #12274F !important;
        background: #E4EDFA;
        text-align: left;
    }

    th:nth-child(1) {
        padding-left: 12px;
    }

    th:nth-child(2) {
        padding-left: 6px;
    }
}

.error-message {
    color: red;
    margin-top: 5px;
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-input--selection-controls {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }
}

</style>
